import { action, makeObservable } from 'mobx';
import { CreateBoxForm } from 'modules/product/forms';
import { BaseViewStore } from 'core/stores';
import { LookupStore } from 'modules/lookup/stores';
import { lookupRouteName, lookupNames, sourceOfChange } from 'common/constants';
import { formInvalidate } from 'core/utils';
import _ from 'lodash';

class CreateBoxViewStore extends BaseViewStore {
	form = new CreateBoxForm();

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
		this.parentView = this.rootStore.productEditViewStore;
		this.lookupStore = new LookupStore(this.rootStore);
	}

	@action.bound async createBox() {
		this.form.validate().then(async ({ isValid }) => {
			if (isValid) {
				this.suspend();
				try {
					const boxFormValues = this.form.values();
					const response = await this.lookupStore.createLookup(
						boxFormValues,
						lookupRouteName.box,
						sourceOfChange.createLookup
					);
					if (response.message) {
						this.form.invalidate(response.message);
					} else {
						var savedItem = this.lookupStore.item;
						this.rootStore.notificationStore.success([
							'LOOKUPCREATE.LOOKUP',
							{ name: savedItem.name, lookup: lookupNames.box },
						]);
						this.parentView.boxOptions.push({ value: savedItem.id, label: savedItem.name, extra: savedItem });
						this.parentView.form.$('dimensionsStep.box').value = {
							value: savedItem.id,
							label: savedItem.name,
							extra: savedItem,
						};
						this.parentView.createBoxModal.close();
					}
				} catch (err) {
					this.form.showErrors(true);
					formInvalidate({ form: this.form, err });
				}
				this.resume();
			} else {
				this.form.showErrors(true);
			}
		});
	}

	@action.bound async onBack() {
		this.parentView.closeCreateBoxModal();
	}
}

export default CreateBoxViewStore;



// WEBPACK FOOTER //
// ./src/modules/product/stores/CreateBoxViewStore.js